





















import {Component, Vue, Prop} from 'vue-property-decorator';

@Component
export default class NewsItemBlock extends Vue {
  @Prop({default: {}}) newsItem!: {};

  getItem(item) {
    this.$emit('getItem', item);
  }
}
